import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=18e2f3d4&"
import script from "./ModalHeader.vue?vue&type=script&lang=ts&"
export * from "./ModalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports